module.exports = __webpack_public_path__ + "static/media/BTMF_logo_white@3x.e01076f7.png";